export default __webpack_public_path__ + "static/freshMS-9b75808ea86418530ba9100ae87d0ec7.jpg";